import { render } from "./ExpireDateComponent.vue?vue&type=template&id=223d2c2e"
import script from "./ExpireDateComponent.vue?vue&type=script&lang=js"
export * from "./ExpireDateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__